module.exports = __webpack_public_path__ + "img/US.0fb47e26.png";